<template>
  <b-modal
    id="createDevice"
    ref="createDevice"
    :title="'device_create' | i18n"
    :ok-title="'create' | i18n"
    :cancel-title="'abort' | i18n"
    ok-variant="primary"
    :ok-disabled="!isNewDeviceValid"
    cancel-variant="outline-primary"
    button-size="sm"
    @ok="createDevice"
  >
    <text-input
      v-model="newDevice.deviceNumber"
      :placeholder="'number_short' | i18n"
      form-group-id="number_short"
      :required="true"
    />
    <text-input
      v-model="newDevice.deviceId"
      placeholder="App-Id"
      form-group-id="App-Id"
      :required="true"
    />
    <text-input
      v-model="newDevice.belongsToEmployee"
      :placeholder="'employee' | i18n"
      form-group-id="employee"
      :required="true"
    />
    <text-input
      v-model="newDevice.notes"
      :placeholder="'device_notes' | i18n"
      form-group-id="device_notes"
      :required="true"
    />
  </b-modal>
</template>

<script>
import { DeviceMixin, NotificationMixin } from '../../../../mixins';
import TextInput from '../../../inputs/text';

export default {
  name: 'EditDevice',
  components: { TextInput },
  mixins: [DeviceMixin, NotificationMixin],
  props: {
    update: {
      type: Function,
      default: () => {},
    },
  },
  data: function() {
    return {
      newDevice: {
        deviceNumber: null,
        deviceId: null,
        notes: null,
        belongsToEmployee: null
      },
    };
  },
  computed: {
    isNewDeviceValid: function () {
      return !!this.newDevice.deviceId && !!this.newDevice.deviceNumber;
    },
  },
  methods: {
    async createDevice() {
      try {
        await this.deviceService.createDevice(this.newDevice);
        this.update();
        this.showNotification({type: 'success', title: this.$translate('device_create'), message: this.$translate('device_create_success')});
        this.newDevice = {
          deviceNumber: null,
          deviceId: null,
          notes: null,
          belongsToEmployee: null
        };
      } catch (err) {
        this.showNotification({type: 'error', title: this.$translate('device_create'), message: err.message});
      }
    },
  },
};
</script>

<style scoped lang="scss">
.owner-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.owner-block {
  height: 60px;
  display: flex;
  justify-content: center;
  border-radius: 0.2rem;
  box-shadow: 0px 0px 17px -7px rgba(0, 0, 0, 0.35);
  width: fit-content;
  padding: 10px;
  margin: 10px;
  flex-direction: column;
}
</style>
